import * as BettingModeActions from 'actions/BettingMode';
import * as StorageActions from 'actions/Storage';
import * as AcceptFactorChangeMode from 'constants/AcceptFactorChange';

export default function (bettingMode, action) {
    switch (action.type) {
        case StorageActions.LOAD_STORAGE: {
            const storageBettingMode = action.data.bettingMode;
            if (storageBettingMode) {
                return storageBettingMode;
            }
            return bettingMode;
        }

        case BettingModeActions.TOGGLE_ONE_CLICK_MODE:
            return bettingMode.set('isOneClick', !bettingMode.get('isOneClick'));

        case BettingModeActions.SET_ACCEPT_FACTOR_CHANGE_MODE:
            return bettingMode.set('acceptFactorChange', action.data);

        case BettingModeActions.TOGGLE_ACCEPT_FACTOR_INCREASE:
            return setAcceptFactorChangeOnAcceptIncrease(bettingMode, action.data);

        case BettingModeActions.TOGGLE_ACCEPT_FACTOR_DECREASE:
            return setAcceptFactorChangeOnAcceptDecrease(bettingMode, action.data);

        case BettingModeActions.SET_ONE_CLICK_AMOUNT:
            return bettingMode.set('oneClickAmount', action.data);

        case BettingModeActions.SET_FAVOURITE_BET_AMOUNT:
            return setFavouriteBetAmount(bettingMode, action.data);
    }

    return bettingMode;
}

function setFavouriteBetAmount(bettingMode, favouriteBet) {
    switch (favouriteBet.number) {
        case 1:
            return bettingMode.set('favouriteBet1Amount', favouriteBet.amount);
        case 2:
            return bettingMode.set('favouriteBet2Amount', favouriteBet.amount);
        case 3:
            return bettingMode.set('favouriteBet3Amount', favouriteBet.amount);
    }

    return bettingMode;
}

function setAcceptFactorChangeOnAcceptIncrease(bettingMode, acceptIncrease) {
    const currentMode = bettingMode.get('acceptFactorChange');

    if (acceptIncrease) {
        if (!currentMode || currentMode === AcceptFactorChangeMode.NONE) {
            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.INCREASE);
        } else if (currentMode === AcceptFactorChangeMode.DECREASE) {
            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.BOTH);
        }
    } else {
        if (currentMode && currentMode === AcceptFactorChangeMode.BOTH) {
            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.DECREASE);
        } else if (currentMode === AcceptFactorChangeMode.INCREASE) {
            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.NONE);
        }
    }

    return bettingMode;
}

function setAcceptFactorChangeOnAcceptDecrease(bettingMode, acceptDecrease) {
    const currentMode = bettingMode.get('acceptFactorChange');

    if (acceptDecrease) {
        if (!currentMode || currentMode === AcceptFactorChangeMode.NONE) {
            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.DECREASE);
        } else if (currentMode === AcceptFactorChangeMode.INCREASE) {
            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.BOTH);
        }
    } else {
        if (currentMode && currentMode === AcceptFactorChangeMode.BOTH) {
            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.INCREASE);
        } else if (currentMode === AcceptFactorChangeMode.DECREASE) {
            return bettingMode.set('acceptFactorChange', AcceptFactorChangeMode.NONE);
        }
    }

    return bettingMode;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/bettingModeReducer.js